export default __webpack_public_path__ + "static/media/AutolysisFigure1.9f4310c3.svg";